import { useNavigate, useLocation } from "react-router-dom";
import React from "react";
import { Button, Table, Modal } from "react-bootstrap";

//Icon
import { FaCircleCheck } from "react-icons/fa6";
import { FcDocument } from "react-icons/fc";
import { SlOptions } from "react-icons/sl";

import cancel from "../../../picture/cancel.png";
import { useState,useEffect } from "react";
import InformationData from "../../user/drone/Datadrone";

export default function UserPage(props) {
  let Navigate = useNavigate();
  const [registrationStatus, setRegistrationStatus] = useState({
    userInfo:false,
    droneInfo:false,
    pilotInfo:false,
    pilotGeneral:false,
    pilotAdvanced:false,
  });
  function EditRegis() {
    Navigate("/profile/editprofileuser", {
      state: {
        href: window.location.href,
      },
    });
  }
async function SetupRegisStatus(){
    setRegistrationStatus({
      userInfo:props.data.profile_set??false,
      droneInfo:sessionStorage.getItem("operator_id")!=="null"?true:false,
      pilotInfo:sessionStorage.getItem("pilot_id")!=="null"?true:false,
      pilotGeneral:sessionStorage.getItem("pilot_code_open")!=="null"?true:false,
      pilotAdvanced:(sessionStorage.getItem("pilot_code_specific")!=="null"&&sessionStorage.getItem("pilot_code_specific")!=="")?true:false,
    });
}

  useEffect(() => {
    const StateUp =async ()=>{
      await SetupRegisStatus();
    }
    StateUp();
  }, []);
  console.log(registrationStatus);
  return (
    <>
      <h2 className="profile-header">ข้อมูลบัญชี</h2>
      <div className="user-main">
        <div className="user-wrap">
          <span className="user-icon">
            <div className="icon-character">
              {props.data.f_name === undefined
                ? props.data.company_name === undefined
                  ? "Null"
                  : props.data.email.charAt(0)
                : props.data.f_name === null
                  ? props.data.email.charAt(0)
                  : props.data.f_name.charAt(0)}
            </div>
          </span>
          <h3>
            {props.data.f_name === undefined ? props.data.company_name ? props.data.company_name : "None" : props.data.f_name} {props.data.l_name ?? null}
          </h3>
          <a style={{ color: "gray" }}>
            เป็นสมาชิกตั้งแต่ {props.data.created_at ?? null}
          </a>
        </div>

        <div className="user-deshboard" >
          <div className="user-desh-left">
            <div className="user-desh-box" >
              <div className="user-desh-title">
                <h5>ขั้นตอนการลงทะเบียนใช้งาน</h5>
              </div>
              <div className="user-desh-content" style={{ padding: "10px" }}>
                <ul className="secure_list">
                  <li className="item" style={{ marginTop: 0 }}>
                    <a className="check-box"  style={{ cursor: "pointer"}} onClick={()=>Navigate("/profile/editprofileuser", {state: {href: window.location.href}})}>ลงทะเบียนรายละเอียดผู้ใช้</a>
                    <span style={{color:"red"}}>*</span>
                    <span className="btn_secure">
                      <li className="icn_svg">
                        <FaCircleCheck color={registrationStatus.userInfo?"green":"gray"} style={{ width: 25, height: 25, opacity: 0.85 }} />
                      </li>
                    </span>
                  </li>
                  <li className="item">
                    <a className="check-box" style={{ cursor: "pointer"}} onClick={()=>Navigate("/user/drone/regisDrone", {state: {href: window.location.href}})}>ลงทะเบียนโดรน</a>
                    <span className="btn_secure">
                      <li className="icn_svg">
                        <FaCircleCheck color={registrationStatus.droneInfo?"green":"gray"} style={{ width: 25, height: 25, opacity: 0.85 }} />
                      </li>
                    </span>
                  </li>
                  <li className="item">
                    <a className="check-box" style={{ cursor: "pointer"}} onClick={()=>Navigate("/user/pilot/regispilot", {state: {href: window.location.href}})}>ลงทะเบียนนักบิน</a>
                    <span className="btn_secure">
                      <li className="icn_svg">
                        <FaCircleCheck color={registrationStatus.pilotInfo?"green":"gray"} style={{ width: 25, height: 25, opacity: 0.85 }} />
                      </li>
                    </span>
                  </li>


                  <div style={{ marginLeft: 20 }}>
                    <li className="item">
                      <a className="check-box" style={{ cursor: "pointer"}} onClick={()=>Navigate("/user/pilot/regispilot", {state: {href: window.location.href}})}>- นักบินทั่วไป</a>
                      <span className="btn_secure">
                        <li className="icn_svg">
                          <FaCircleCheck color={registrationStatus.pilotGeneral?"green":"gray"} style={{ width: 25, height: 25, opacity: 0.85 }} />
                        </li>
                      </span>
                    </li>
                    <li className="item">
                      <a className="check-box" style={{ cursor: "pointer"}} onClick={()=>Navigate("/user/pilot/regispilotspacific", {state: {href: window.location.href}})}>- นักบินขั้นสูง</a>
                      <span className="btn_secure">
                        <li className="icn_svg">
                          <FaCircleCheck color={registrationStatus.pilotAdvanced?"green":"gray"} style={{ width: 25, height: 25, opacity: 0.85 }} />
                        </li>
                      </span>
                    </li>
                  </div>


                </ul>
              </div>
            </div>
          </div>
          <div className="user-desh-right">
            <div className="user-desh-box account">
              <div className="user-desh-title">
                <a
                  href="/profile/editprofileuser"
                  onClick={EditRegis}
                  className="btn-more"
                >
                  <i className="dash-more">
                    <SlOptions size={21} />
                  </i>
                </a>
                <h5>บัญชี</h5>
              </div>

              <div>
                <p>{props.data.email ?? "none"}</p>
                <p>แก้ไขล่าสุดเมื่อ {props.data.updated_at ?? "-"}</p>
                <Button variant="secondary" size='sm' style={{ width: "100%" }} disabled>เปลี่ยนรหัสผ่าน</Button>
              </div>
            </div>
            {/* <div className="user-desh-box logged">เข้าสู่ระบบล่าสุด</div> */}
            <div className="user-desh-box secure">ความปลอดภัย</div>

          </div>

        </div>
      </div>
    </>
  );
};


